import _get from 'lodash/get';
import getConfig from '@bonnet/core/config';
import { getMarket } from '@atc/bonnet-reference';
const adTargetingFilter = params => {
  const makeCode = _get(params, 'makeCode', '');
  const modelCode = _get(params, 'modelCode', '');
  const seriesCode = _get(params, 'seriesCode', '');
  const type = _get(params, 'type', '');
  let vehicleStyleCode = _get(params, 'vehicleStyleCode', '');

  // default values
  const adParam = {
    abody: 'none',
    amake: 'none',
    amod: 'none',
    bstyl: 'none',
    mke: 'none',
    type: 'all',
    mdl: 'none',
    series: 'none',
    asr: 'none'
  };
  if (type) {
    adParam.type = type;
  }

  // make code
  if (makeCode) {
    adParam.mke = makeCode;
    adParam.amake = makeCode;
  }

  // model code
  if (modelCode && makeCode && typeof modelCode === 'string' && typeof makeCode === 'string') {
    adParam.mdl = modelCode;
    adParam.amod = makeCode.toUpperCase() + '_' + modelCode.toUpperCase();
  }
  if (seriesCode && makeCode && typeof seriesCode === 'string' && typeof makeCode === 'string') {
    adParam.asr = seriesCode;
    adParam.series = seriesCode;
    if (!modelCode) {
      adParam.mdl = seriesCode;
      adParam.amod = makeCode.toUpperCase() + '_' + seriesCode.toUpperCase();
    }
  }

  // style code
  if (vehicleStyleCode) {
    switch (vehicleStyleCode) {
      case 'SUVCROSS':
        {
          vehicleStyleCode = 'SUV';
          break;
        }
      case 'VANMV':
        {
          vehicleStyleCode = 'VANS';
          break;
        }
      default:
        break;
    }
    adParam.abody = vehicleStyleCode;
    adParam.bstyl = vehicleStyleCode;
  }
  return adParam;
};
const yearRange = (startYear, endYear) => {
  const range = ['1', '2', '2', '2', '3', '3', '3', '3', '4'];
  const date = new Date();
  const end = endYear || date.getFullYear();
  if (startYear !== 'nl' && endYear !== 'nl') {
    let index = Number(end) - Number(startYear);
    if (index < 0) {
      index = 0;
    } else if (index > 8) {
      index = 8;
    }
    return range[index] ? range[index].toString() : 'nl';
  }
  return 'nl';
};
const getAlphaZoneCode = async function () {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    alphaZoneCode,
    zip
  } = params;
  const {
    payload: market
  } = zip && zip !== 'nl' ? await getMarket(zip) : {};
  // This alphaZoneCode from params is part of the service response for the alpha service since alphaZoneCode can be
  // make dependent, and we don't know which make/zone were used ahead of time.
  if (alphaZoneCode) {
    // Because we still have one ad flighted to the legacy alpha zones from the markets table (skyscraper ad on srp)
    // We are going to add the legacy code if it exists and is different from the zone returned from the alpha call.
    return market !== null && market !== void 0 && market.legacyAlphaZoneCode && alphaZoneCode !== (market === null || market === void 0 ? void 0 : market.legacyAlphaZoneCode) ? alphaZoneCode + ',' + (market === null || market === void 0 ? void 0 : market.legacyAlphaZoneCode) : alphaZoneCode;
  }
  return (market === null || market === void 0 ? void 0 : market.alphaZoneCode) || 'nl';
};
export default function addAdParameters() {
  let {
    params = {},
    dataKey = 'ads'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return async ctx => {
    const {
      publicRuntimeConfig
    } = getConfig();
    const adTarget = adTargetingFilter(params);
    const zip = _get(params, 'zip');
    const alphaZoneCode = await getAlphaZoneCode(params);
    const startYear = _get(params, 'startYear', 'nl');
    const styr = _get(params, 'qStartYear', '') || startYear;
    const endYear = _get(params, 'endYear', 'nl');
    const eyr = _get(params, 'qEndYear', '') || endYear;
    const yrange = _get(params, 'qStartYear', '') ? yearRange(startYear) : yearRange(styr, eyr);
    const pixallId = _get(params, 'pixallId', 'nl');
    const adsLazyLoadingOffset = _get(params, 'adsLazyLoadingOffset', '');
    const lazyLoadingOffset = _get(params, 'lazyLoadingOffset', '');
    const optional = _get(params, 'optionalParams', {});
    let env = process.env.ENVIRONMENT;

    // process.env cannot use in client-side
    if (!_get(ctx, 'req', false)) {
      env = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.environment;
    }
    const adParams = {
      adUnit: _get(params, 'adUnit', '/18353239/' + process.env.AD_CONFIG + '/global'),
      pageLevelTargeting: {
        asr: adTarget.asr,
        tprice: _get(params, 'maxPrice', 'nl'),
        fprice: _get(params, 'minPrice', 'nl'),
        type: adTarget.type,
        mke: adTarget.mke,
        kmake: _get(params, 'kmake', 'nl'),
        amake: adTarget.amake,
        pginst: _get(params, 'pgInst', 'nl'),
        bstyl: adTarget.bstyl,
        abody: adTarget.abody,
        kbody: _get(params, 'kbody', 'nl'),
        amod: adTarget.amod,
        kmod: _get(params, 'kmod', 'nl'),
        mdl: adTarget.mdl,
        mdlid: _get(params, 'mdlid', 'nl'),
        fueltype: _get(params, 'fueltype', 'none'),
        series: adTarget.series,
        siomid: _get(params, 'siomid', 'nl'),
        yr: _get(params, 'startYear', 'nl'),
        pkgtyp: 'nl',
        styr,
        uuid: _get(params, 'uuid', 'nl'),
        exp: _get(params, 'device', 'should be browser'),
        azne: alphaZoneCode,
        zip,
        anml: _get(params, 'anml', 'n'),
        lng: _get(params, 'language', 'en'),
        ip: _get(params, 'ip', 'nl'),
        list: _get(params, 'list', 'nl'),
        asubseg: _get(params, 'asubseg', 'nl'),
        pixall: pixallId,
        eyr,
        yrange,
        cid: 'nl',
        osid: _get(params, 'osid', 'nl'),
        btc: _get(params, 'btc', 'nl'),
        sec: _get(params, 'sec', 'nl'),
        ksubseg: _get(params, 'ksubseg', 'nl'),
        cat: _get(params, 'cat', 'nl'),
        dpg: _get(params, 'dpg', 'nl'),
        gadpn: _get(params, 'gadpn') || _get(params, 'dpg', 'nl'),
        st: _get(params, 'state'),
        os: _get(params, 'os', 'nl'),
        env: env === 'prod' ? 'prod' : 'nonprod',
        int: 'nl',
        ownid: _get(params, 'ownid', 'nl'),
        listing_id: _get(params, 'listing_id', 'nl'),
        lprice: _get(params, 'lprice', 'nl'),
        kvid: _get(params, 'kvid', 'nl'),
        pg: _get(params, 'pg', 'nl'),
        // replaced by gapg
        gapg: _get(params, 'gapg') || _get(params, 'pg', 'nl'),
        dyn: _get(params, 'dyn', 'nl'),
        betagrp: _get(params, 'betaGroup', 'nl'),
        dma: _get(params, 'dma', 'nl'),
        ptnr: 'atc',
        pixall_visitorid: pixallId,
        mcmid: _get(params, 'mcmid', 'nl'),
        ss: _get(params, 'ss', 'nl'),
        // replaced by gasec
        gasec: _get(params, 'gasec') || _get(params, 'ss', 'nl'),
        psid: _get(params, 'psid', 'nl'),
        lnx: _get(params, 'lnx', 'nl'),
        certptnr: _get(params, 'certptnr', 'nl'),
        ...optional
      },
      prebidAdapters: [{
        bidder: 'appnexus',
        params: {
          placementId: _get(params, 'placementId', 'nl')
        }
      }]
    };
    if (adsLazyLoadingOffset) {
      adParams.adsLazyLoadingOffset = adsLazyLoadingOffset;
    }
    if (lazyLoadingOffset) {
      adParams.lazyLoadingOffset = lazyLoadingOffset;
    }
    ctx.data[dataKey] = adParams;
  };
}